module.exports = __webpack_public_path__ + "img/v-logo.b94a63d7.png";